import PageHeader from '../../../../layout/page/PageHeader'
import NewsletterForm from './NewsletterForm'

const Create = () => {
    return (
        <>
            <PageHeader
                icon="envelope"
                subtitle="Create a new email campaign"
                gradient="linear-gradient(135deg, #f59e0b, #d97706)"
                header="New Email Campaign"
            />
            <NewsletterForm />
        </>
    )
}

export default Create
